import React from "react"
import { Link, NavLink } from "react-router-dom"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCog } from "@fortawesome/free-solid-svg-icons"

import AccountDropDown from "./AccountDropDown"

class NavBar extends React.Component{
    render(){
        return(
            <div className="navBar" role="banner">
                <Link to="/">
                    <FontAwesomeIcon icon={faCog} />
                </Link>
                <div className="border"></div>
                <NavLink activeClassName="active" to="/" className="category">Arcade</NavLink>
                <a className="category" href="https://forum.wildsky.dev">Forum</a>
                <AccountDropDown/>
            </div>
        )
    }
}

export default NavBar